<template>
  <div>
    <!-- Row top buttons -->
    <div class="row q-mb-lg">
      <div class="col-6" style="justify-content: flex-start">
        <q-btn
          class="capitalize ctrl-button"
          color="grey-5"
          :label="getString('action.toOverview')"
          @click="$router.push(`/${module}`)"
          icon="keyboard_backspace"
        />
      </div>
      <div class="col-6">
        <q-btn
          ref="save"
          class="capitalize ctrl-button right q-mr-lg"
          :color="disable ? 'grey-5' : 'ctrl-turquoise'"
          :label="disable ? getString('action.edit') : getString('action.save')"
          @click="save"
          :icon-right="disable ? 'edit' : 'save'"
        />
        <q-btn
          v-if="
            data.id &&
            $store.state.meStore.me.rights.includes(`${permission}.delete`)
          "
          :disable="disable"
          class="q-mr-md capitalize ctrl-button right"
          icon-right="delete"
          color="negative capitalize"
          :label="getString('action.delete')"
          align="right"
          @click="deleteCategory()"
        />
      </div>
    </div>

    <!-- Columns -->
    <div class="row gutter-sm q-mb-lg">
      <!-- Left -->
      <div class="col-md-6 col-sm-12 col-xs-12 q-pa-sm">
        <div class="row q-mb-sm">
          <div class="full-width">
            <p class="card-title">
              {{ getString('module.name.spare-part-categories') }}
            </p>

            <div class="card-block" v-if="dataLoaded">
              <div class="row">
                <q-field
                  :error-label="errorMessage('label')"
                  class="full-width q-mb-md"
                >
                  <q-input
                    type="text"
                    :disable="disable"
                    class="full-width q-mb-md"
                    float-label="Label"
                    @blur="$v.data.label.$touch()"
                    :error="$v.data.label.$anyError"
                    v-model="data.label"
                  />
                </q-field>

                <q-field
                  :error-label="errorMessage('code_to_match')"
                  class="full-width q-mb-md"
                >
                  <q-input
                    type="text"
                    :disable="disable"
                    class="full-width q-mb-md"
                    float-label="Code"
                    @blur="$v.data.code_to_match.$touch()"
                    :error="$v.data.code_to_match.$anyError || isDuplicatedCode"
                    v-model="data.code_to_match"
                  />
                </q-field>
                <q-field class="full-width q-mb-md">
                  <q-select
                    v-if="iconsDropdown.length && svgsLoaded"
                    :disable="disable"
                    :float-label="
                      getString(null, 'Icon', 'Icoon')
                    "
                    v-model="data.icon_id"
                    :options="iconsDropdown"
                  />
                </q-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- right -->
      <div class="col-md-6 col-sm-12 col-xs-12 q-pa-sm">
        <div class="row q-mb-sm">
          <div class="full-width" v-if="data.icon_id">
            <p class="card-title">{{ getString('action.preview') }}</p>
            <div class="category-box">
              <div v-html="svgIcon" class="category-box__svg"></div>
              <span>{{ data.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';

// Mixins
import fetchDetail from '@/mixins/detailViews/fetchDetail';
import saveChanges from '@/mixins/detailViews/saveChanges';
import getString from '@/helpers/GetStrings';
import common from './common';

export default {
  mixins: [fetchDetail, common, saveChanges],
  validations: {
    data: {
      label: {
        required,
        maxLength: maxLength(50),
      },
      code_to_match: {
        required,
        maxLength: maxLength(50),
      },
    },
  },
  data() {
    return {
      disable: false,
      containsErrors: true,
      svgsLoaded: false,
      responseData: {},
      data: {
        id: null,
        label: '',
        code_to_match: '',
        icon_id: null,
      },
      existingCodes: [],
      icons: [],
      iconsDropdown: [],
      iconSelected: 1,
    };
  },

  methods: {
    getString,
    deleteCategory() {
      // Dialog
      this.$q
        .dialog({
          title: '',
          message: `${
            this.isNl ? 'Categorie verwijderen - ' : 'Delete category - '
          }${this.data.label} ?`,
          ok: getString('dialog.confirm.ok'),
          cancel: getString('dialog.confirm.cancel'),
        })
        .then(() => {
          // delete call
          this.axios
            .delete(`${this.endpoint}/${this.data.id}`)
            .then(() => {
              // Refresh data to see the result
              this.$q.notify({
                message: '*Category removed.',
                position: 'top-right',
                timeout: 1000,
                color: 'positive',
              });
              this.$router.push(`/${this.module}`);
            })
            .catch((error) => {
              // Error
              console.warn(error);
            });
        })
        .catch(() => {
          console.warn('Not removed');
        });
    },
    save() {
      if (this.disable) {
        this.disable = false;
        return;
      }
      this.$v.data.$touch();
      if (this.$v.data.$anyError) return;
      this.saveChanges();
    },
    errorMessage(field) {
      if (!this.$v.data[field].maxLength) {
        return this.isNl
          ? 'De maximale lengte is 50 tekens'
          : 'The maximum length is 50 characters';
      }
      if (this.isDuplicatedCode && field === 'code_to_match') {
        return this.isNl
          ? 'Deze waarde bestaat al in de database'
          : 'This value already exists in the database';
      }
      return this.isNl ? 'Dit veld is verplicht' : 'This field is required';
    },
    requestParams() {
      return this.data;
    },
  },
  computed: {
    isNl() {
      return this.$store.state.stringsStore.language === 'nl';
    },
    isDuplicatedCode() {
      return this.existingCodes.includes(this.data.code_to_match.toUpperCase());
    },
    svgIcon() {
      const icon = this.icons.find(i => i.id === this.data.icon_id);
      return icon ? icon.svg : 'no icon available';
    },
  },
  async mounted() {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(this.$route.params.id)) this.disable = true;
    else this.$route.params.id = null;
    await this.axios.get('svgicons/spare-part-category').then((res) => {
      this.icons = res.data.svg_icons;
      this.iconsDropdown = this.icons.map(i => ({
        label: i.name,
        value: i.id,
      }));
      this.svgsLoaded = true;
      if (!this.data.icon_id) this.data.icon_id = this.icons[0].id;
    });
  },
};
</script>

<style lang="stylus" scoped>
.category-box {
  background: #fff;
  border-radius: 3px;
  border: 1px solid #E2001A;
  color: #E2001A;
  padding: 20px;
  margin: auto;
  margin-top: 75px;
  cursor: pointer;
  width: 180px;
  height: 180px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  text-transform: capitalize;

  &__svg {
    width: 120px;
    height: 100%;
    margin: auto;
    fill: #E2001A;
  }

}
</style>
